module.exports = __webpack_public_path__ + "static/media/Image2BG@2x.ecb71a0a.png";